import {type FC, useCallback, useEffect, useState} from 'react';
import {useNavigate} from 'react-router';
import {Address, BackButton, FoodInfoPageWrapper, Pin, PositionWrapper, Table} from './types/FoodInfoPage.style.ts';
import useCenterStore from '../../store/useCenterStore.ts';
import type {IFoodInfo} from './types';
import FoodInfoRow from './component/FoodInfoRow.tsx';
import {FocusContext, setFocus, useFocusable} from '@noriginmedia/norigin-spatial-navigation';
import callApi from '../../apis/callApi.ts';

const menus = ['분식', '고기집', '한식', '일식', '중식', '양식', ''];

const FoodInfoPage: FC = () => {
    const navigate = useNavigate();
    const {centerInfo} = useCenterStore();
    const [param, setParam] = useState<string>('');

    useEffect(() => {
        setParam(
            centerInfo?.address?.split(' ')[1] + ' ' + centerInfo?.address?.split(' ')[2] + ' ' + `${menus[6]} 맛집`
        );
    }, []);

    const [foodInfo, setFoodInfo] = useState<Array<IFoodInfo>>([]);
    const getFoodData: () => Promise<void> = useCallback(async () => {
        if (param) {
            const {data} = await callApi().get(`/restaurant/naverapi/?query=${param}`);
            setFoodInfo(data.items);
        }
    }, [param]);

    useEffect(() => {
        getFoodData();
    }, [centerInfo?.address, getFoodData]);

    const {ref: foodInfoPageRef, focusKey: foodInfoPageFocusKey} = useFocusable({
        focusKey: 'food-info-page',
        trackChildren: true,
    });

    useEffect(() => {
        setFocus('food-info-back-button');
    }, []);

    const {ref: backBtnRef, focused: backBtnFocused} = useFocusable({
        focusKey: 'food-info-back-button',
        onEnterPress: () => navigate(-1),
        onArrowPress: (direction) => {
            if (direction === 'down') {
                setFocus('food-info-1');
                return false;
            }
            return true;
        },
    });

    return (
        <FocusContext.Provider value={foodInfoPageFocusKey}>
            <FoodInfoPageWrapper ref={foodInfoPageRef}>
                <BackButton ref={backBtnRef} $focused={backBtnFocused} onClick={() => navigate(-1)}>
                    뒤로가기
                </BackButton>
                <PositionWrapper>
                    <Pin>📍</Pin>현재 위치
                </PositionWrapper>
                <Address>{centerInfo?.address}</Address>
                <Table>
                    <tbody>
                        {foodInfo.map((e, index) => (
                            <FoodInfoRow key={e.title} index={index} foodInfo={e} />
                        ))}
                    </tbody>
                </Table>
            </FoodInfoPageWrapper>
        </FocusContext.Provider>
    );
};

export default FoodInfoPage;
